import PropTypes from "prop-types";
import React, { useState } from "react";
import DropToUpload from "react-drop-to-upload";
import { toast } from "react-toastify";
import "./DropToUploadField.css";
/**
 * Zone pour uploader des fichiers via drag&drop
 * @class
 * @category Fields
 * @param {Fields.DropToUploadField.propTypes} props Les propriétés du composant
 */

function DropToUploadField(props) {
  // Récupération des props
  var className = props.className,
      height = props.height,
      onUpload = props.onUpload,
      width = props.width; // Initialisation du state

  var _useState = useState(false),
      isOver = _useState[0],
      setIsOver = _useState[1]; // Fonction appelée lors du survol de la zone pendant un drag


  var handleOnOver = function handleOnOver() {
    // Ajout du style hover
    if (!isOver) {
      setIsOver(true);
    }
  }; // Fonction appelée à la fin du survol de la zone pendant un drag


  var handleOnLeave = function handleOnLeave() {
    // Suppression du style hover
    setIsOver(false);
  }; // Fonction appelée lors du drop des fichiers


  var handleDropDataURI = function handleDropDataURI(dataURIs, files) {
    var names = [];
    var data = [];

    for (var i = 0; i < files.length; i++) {
      // Taille des fichiers limitée à 5Mo
      if (files[i].size > 5242880) {
        toast.error("La taille du fichier \"" + files[i].name + "\" est sup\xE9rieure \xE0 5Mo");
        continue;
      }

      names.push(files[i].name);
      data.push(dataURIs[i]);
    }

    if (onUpload) {
      onUpload(names, data);
    } // Suppression du style hover


    setIsOver(false);
  }; // Interface


  var style = className ? "DropToUpload " + className : "DropToUpload DropToUploadDefault";
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: width,
      height: height,
      marginBottom: "10px"
    }
  }, /*#__PURE__*/React.createElement(DropToUpload, {
    className: isOver ? style + " DropToUploadHover" : style,
    dropEffect: "copy",
    onOver: handleOnOver,
    onLeave: handleOnLeave,
    onDropDataURI: handleDropDataURI
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-file-upload",
    style: {
      fontSize: "2em",
      marginBottom: "10px"
    }
  }), "D\xE9posez vos fichiers ici"));
} // #region PROPRIETES

/**
 * Type des propriétés de {@link DropToUploadField}
 * @typedef {Object} DropToUploadField.propTypes
 * @property {function} onUpload La fonction de callback appelée pour charger un fichier
 * @property {string} [className=null] La classe du champ
 * @property {string} [width=100%] La largeur du champ
 * @property {string} [height=100px] La hauteur du champ
 */


DropToUploadField.propTypes = process.env.NODE_ENV !== "production" ? {
  onUpload: PropTypes.func.isRequired,
  className: PropTypes.string,
  width: PropTypes.string,
  height: PropTypes.string
} : {};
/*
  Valeurs par défaut des propriétés
*/

DropToUploadField.defaultProps = {
  className: null,
  width: "100%",
  height: "100px"
}; // #endregion

export { DropToUploadField };